import HeaderButton from "@shared/ui/header-button/header-button";
import HeaderContent from "@shared/ui/header-content/header-content";
import { TabMenu, TabMenuTabChangeEvent } from "primereact/tabmenu";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import { useListCardsContext } from "./list-cards.context";

export function ListCards() {
  // THIS IS THE LOCAL DECLARATION
  const navigate = useNavigate();
  const location = useLocation();
  const [tabActiveIndex, setTabActiveIndex] = useState(0);
  const items = [
    { label: "Campaign", icon: "pi pi-file-edit" },
    { label: "Activity", icon: "pi pi-chart-line" },
    { label: "Redeemed Items", icon: "pi pi-chart-line" },
  ];

  // THIS IS THE QUERY DECLARATION
  const { cardsElement, cardDetailsElement, actions, handleAction } =
    useListCardsContext();

  // THIS IS THE LOCAL RENDERS
  // THIS IS THE LOCAL DECLARATION
  useEffect(() => {
    const paths = location.pathname.split("/").filter((item) => !!item);

    if (paths.length === 1) {
      setTabActiveIndex(0);
      return;
    }

    let current = "";
    if (paths.length === 2) {
      current = paths[paths.length - 1];
    } else if (paths.length > 3) {
      current = paths[2];
    }

    switch (current) {
      case "activity":
        setTabActiveIndex(1);
        return;
      case "redeemed-items":
        setTabActiveIndex(2);
        return;

      default:
        setTabActiveIndex(0);
        return;
    }
  }, [location]);
  const handleTabChange = (e: TabMenuTabChangeEvent) => {
    switch (e.index) {
      case 0:
        navigate(``);
        break;
      case 1:
        navigate(`activity`);
        break;
      case 2:
        navigate(`redeemed-items`);
        break;
    }

    setTabActiveIndex(e.index);
  };

  return (
    <div id="ListCards" className="customer">
      <HeaderContent title={<h1>Cards</h1>}>
        <div className="flex flex-between">
          <HeaderButton actions={actions} onAction={handleAction} />
        </div>
      </HeaderContent>
      <div>
        {cardsElement}
        <TabMenu
          model={items}
          activeIndex={tabActiveIndex}
          onTabChange={handleTabChange}
        />
        {cardDetailsElement}
      </div>
    </div>
  );
}

export default ListCards;
